var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "dc_customize" } },
    [
      _c("dd-header", { ref: "menuRef" }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("h1", { staticClass: "hidden" }, [
                  _vm._v("商品カスタマイズ")
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", { staticClass: "hidden" }, [_vm._v("商品情報")]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "product_header" } }, [
                    _c("div", { staticClass: "produt_info" }, [
                      _vm.targetPlan.makerData
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.targetPlan.makerData.corpName))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.targetPlan.seriesName))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.targetPlan.dcFdName))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "product_option" }, [
                      _c("div", { staticClass: "manual" }, [
                        _c(
                          "span",
                          {
                            class: {
                              disabled: !_vm.targetPlan.cDcProductManual
                            },
                            on: {
                              click: function($event) {
                                _vm.downloadManual(
                                  _vm.targetPlan.cDcProductManual
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.getImage("common/PDF.svg") }
                            }),
                            _vm._v(" "),
                            _c("figcaption", [_vm._v("商品説明書")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            class: {
                              disabled: !_vm.targetPlan.cDcConstructManual
                            },
                            on: {
                              click: function($event) {
                                _vm.downloadManual(
                                  _vm.targetPlan.cDcConstructManual
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.getImage("common/PDF.svg") }
                            }),
                            _vm._v(" "),
                            _c("figcaption", [_vm._v("設置説明書")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            class: { disabled: !_vm.targetPlan.cDcUserManual },
                            on: {
                              click: function($event) {
                                _vm.downloadManual(_vm.targetPlan.cDcUserManual)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.getImage("common/PDF.svg") }
                            }),
                            _vm._v(" "),
                            _c("figcaption", [_vm._v("取扱説明書")])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "detail_btn4 btn_pos_product",
                          on: {
                            click: function($event) {
                              _vm.route("SupportInput", {
                                maker: _vm.targetPlan.makerData.corpId
                              })
                            }
                          }
                        },
                        [_vm._v("この商品について問い合わせる")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { attrs: { id: "product-big-image" } }, [
                      _c("img", {
                        attrs: { src: _vm.getImage(_vm.targetPlan.dcFdImageB) }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.constructList && _vm.constructList.length > 0
                    ? _c(
                        "div",
                        { attrs: { id: "construct" } },
                        [
                          _c("dd-consturct", {
                            ref: "ddCategoryListRef",
                            attrs: {
                              swipeList: _vm.constructList,
                              swiperOptions: _vm.constructOptions,
                              horizontalMode: false
                            },
                            on: { clickImage: _vm.previewConstruct }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "product_option_sp" }, [
                    _c("div", { staticClass: "manual" }, [
                      _c(
                        "span",
                        {
                          class: { disabled: !_vm.targetPlan.cDcProductManual },
                          on: {
                            click: function($event) {
                              _vm.downloadManual(
                                _vm.targetPlan.cDcProductManual
                              )
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.getImage("common/PDF.svg") }
                          }),
                          _vm._v(" "),
                          _c("figcaption", [_vm._v("商品説明書")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: {
                            disabled: !_vm.targetPlan.cDcConstructManual
                          },
                          on: {
                            click: function($event) {
                              _vm.downloadManual(
                                _vm.targetPlan.cDcConstructManual
                              )
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.getImage("common/PDF.svg") }
                          }),
                          _vm._v(" "),
                          _c("figcaption", [_vm._v("設置説明書")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: { disabled: !_vm.targetPlan.cDcUserManual },
                          on: {
                            click: function($event) {
                              _vm.downloadManual(_vm.targetPlan.cDcUserManual)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.getImage("common/PDF.svg") }
                          }),
                          _vm._v(" "),
                          _c("figcaption", [_vm._v("取扱説明書")])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "detail_btn4 btn_pos_product",
                        on: {
                          click: function($event) {
                            _vm.route("SupportInput", {
                              maker: _vm.targetPlan.makerData.corpId
                            })
                          }
                        }
                      },
                      [_vm._v("この商品について問い合わせる")]
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isOlis
                    ? _c("div", { attrs: { id: "product_order_info" } }, [
                        !_vm.isShelf
                          ? _c("div", [_vm._v("完成品としてお送りします。")])
                          : _c("div", [
                              _vm._v(
                                "この商品はお客様自身で組み立てする商品です。"
                              )
                            ]),
                        _vm._v(" "),
                        !_vm.isShelf
                          ? _c("div", [
                              _c("div", [_vm._v("壁への固定が必要な商品です")])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h3", [_vm._v(_vm._s(_vm.sizeInputTitle))]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "product_tab_content",
                        attrs: { id: "product_size" }
                      },
                      [
                        _vm.isTypeBeamCounter
                          ? _c(
                              "div",
                              [
                                _c("dd-param-shaped-l", {
                                  ref: "paramCommonRef",
                                  attrs: { targetPlan: _vm.targetPlan }
                                })
                              ],
                              1
                            )
                          : _vm.isParamShelfBoard
                            ? _c(
                                "div",
                                [
                                  _c("dd-param-size2", {
                                    ref: "paramCommonRef",
                                    attrs: {
                                      targetPlan: _vm.targetPlan,
                                      isDisableForm: _vm.isSpaceJoincd,
                                      isExecOrder: _vm.isExecOrder,
                                      isShelf: _vm.isShelf,
                                      isShelfType: _vm.isShelfType
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm.categoryType == 4
                              ? _c(
                                  "div",
                                  [
                                    _c("dd-param-size", {
                                      ref: "paramCommonRef",
                                      attrs: {
                                        targetPlan: _vm.targetPlan,
                                        isDisableForm: _vm.isSpaceJoincd,
                                        isExecOrder: _vm.isExecOrder
                                      },
                                      on: { changeWallFlag: _vm.changeWallFlag }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("dd-param-size-filler", {
                                      ref: "paramCommonRef",
                                      attrs: {
                                        targetPlan: _vm.targetPlan,
                                        isDisableForm: _vm.isSpaceJoincd,
                                        isExecOrder: _vm.isExecOrder,
                                        isStruct: _vm.isResearch,
                                        isExistEndPanel: _vm.isExistEndPanel,
                                        isMiura: _vm.isMiuraCompany,
                                        isActiveCG: _vm.isHaseko
                                      }
                                    })
                                  ],
                                  1
                                )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h3", [_vm._v("②商品カラーの選択")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "※ カラー画像について、ご利用のパソコン・スマートフォンのモニターによってカラーの見え方が違ったり、実際の商品と色味や色柄が異なる場合がございます。予めご了承頂きますようお願いいたします。"
                    )
                  ]),
                  _vm._v(" "),
                  _vm.colorStyleList.length > 0
                    ? _c(
                        "div",
                        { attrs: { id: "color-door-style" } },
                        [
                          _c("dd-color-style", {
                            ref: "styleColorDoor",
                            attrs: {
                              title: "扉/エンドパネル/カウンター",
                              styleList: _vm.colorStyleList,
                              selectColorStyle: _vm.selectColorStyle
                            },
                            on: { changeColorStyle: _vm.changeColorStyle }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.doorColorList.length > 0
                    ? _c(
                        "div",
                        { attrs: { id: "color-door" } },
                        [
                          _c("dd-color-pallet", {
                            ref: "colorPalletDoor",
                            attrs: {
                              documentId: "doorId",
                              title: _vm.doorColorTitle,
                              colorList: _vm.doorColorList,
                              color: _vm.colorDoor
                            },
                            on: { selectColor: _vm.selectDoorColor }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.counterColorList.length > 0
                    ? _c(
                        "div",
                        { attrs: { id: "color-counter" } },
                        [
                          _c("dd-color-pallet", {
                            ref: "colorPalletCounter",
                            attrs: {
                              documentId: "counterId",
                              title: "カウンターカラーを選択ください",
                              colorList: _vm.counterColorList,
                              color: _vm.colorCounter
                            },
                            on: { selectColor: _vm.selectCounterColor }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cabineColorList.length > 0
                    ? _c(
                        "div",
                        { attrs: { id: "color-cabine" } },
                        [
                          _c("dd-color-pallet", {
                            ref: "colorPalletCabine",
                            attrs: {
                              documentId: "cabineId",
                              title: "キャビネット/棚/脚カラーを選択ください",
                              colorList: _vm.cabineColorList,
                              color: _vm.colorCabine
                            },
                            on: { selectColor: _vm.selectCabineColor }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("section", [
                  _vm.targetPlan.dcCategoryType == 5
                    ? _c("div", { staticClass: "product_tab_content" }, [
                        _c("h3", [_vm._v("③ご注文数を選択ください")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content_line" }, [
                          _c("label", [_vm._v("ご注文数")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.dcBoardCount,
                                expression: "dcBoardCount"
                              }
                            ],
                            attrs: { type: "text", maxlength: "2" },
                            domProps: { value: _vm.dcBoardCount },
                            on: {
                              keypress: _vm.validateNumber,
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.dcBoardCount = $event.target.value
                                },
                                function($event) {
                                  _vm.dcBoardCount = _vm.inputRestNumber($event)
                                }
                              ],
                              blur: _vm.onBlurOpBoardCount
                            }
                          }),
                          _vm._v("枚\n            ")
                        ])
                      ])
                    : _vm.targetPlan.dcCategoryType !== 4 &&
                      !(
                        _vm.targetPlan.opShelfType === 1 &&
                        _vm.targetPlan.opFillerType === 1
                      )
                      ? _c(
                          "div",
                          {
                            staticClass: "product_tab_content",
                            attrs: { id: "customize_option" }
                          },
                          [
                            _c("h3", [_vm._v("③追加部材をご選択ください。")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input_btn_area" }, [
                              _c("div", [
                                _vm.targetPlan.opShelfType !== 1
                                  ? _c("div", { staticClass: "content_line" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.isAddShelf,
                                            expression: "isAddShelf"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "opt_shelf",
                                          disabled:
                                            _vm.targetPlan.opShelfType == 2
                                        },
                                        domProps: {
                                          checked: Array.isArray(_vm.isAddShelf)
                                            ? _vm._i(_vm.isAddShelf, null) > -1
                                            : _vm.isAddShelf
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.isAddShelf,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.isAddShelf = $$a.concat([
                                                    $$v
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.isAddShelf = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.isAddShelf = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { attrs: { for: "opt_shelf" } },
                                        [_vm._v("可動棚")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.dcShelfCount,
                                            expression: "dcShelfCount"
                                          }
                                        ],
                                        attrs: {
                                          type: "text",
                                          maxlength: "2",
                                          disabled: !_vm.isAddShelf
                                        },
                                        domProps: { value: _vm.dcShelfCount },
                                        on: {
                                          keypress: _vm.validateNumber,
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.dcShelfCount =
                                                $event.target.value
                                            },
                                            function($event) {
                                              _vm.dcShelfCount = _vm.inputRestNumber(
                                                $event
                                              )
                                            }
                                          ],
                                          blur: _vm.onBlurOpShelfCount
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", [_vm._v("枚/列")]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "※列ごとに指定枚数追加されます。"
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.targetPlan.opFillerType !== 1
                                  ? _c("div", { staticClass: "content_line" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.isAddFiller,
                                            expression: "isAddFiller"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "opt_filler",
                                          disabled:
                                            _vm.targetPlan.opFillerType == 2
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.isAddFiller
                                          )
                                            ? _vm._i(_vm.isAddFiller, null) > -1
                                            : _vm.isAddFiller
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.isAddFiller,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.isAddFiller = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.isAddFiller = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.isAddFiller = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { attrs: { for: "opt_filler" } },
                                        [_vm._v("フィラー")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.dcFillerCount,
                                            expression: "dcFillerCount"
                                          }
                                        ],
                                        attrs: {
                                          type: "text",
                                          maxlength: "2",
                                          disabled: !_vm.isAddFiller
                                        },
                                        domProps: { value: _vm.dcFillerCount },
                                        on: {
                                          keypress: _vm.validateNumber,
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.dcFillerCount =
                                                $event.target.value
                                            },
                                            function($event) {
                                              _vm.dcFillerCount = _vm.inputRestNumber(
                                                $event
                                              )
                                            }
                                          ],
                                          blur: _vm.onBlurOpFillerCount
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", [_vm._v("本")]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "※追加フィラーの寸法は、" +
                                            _vm._s(_vm.fillerSize) +
                                            "mm×200mm×1800mmです。"
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                ]),
                _vm._v(" "),
                _c("section", { attrs: { id: "input_delivery" } }, [
                  _c("h3", [_vm._v("④お届け先郵便番号の入力")]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "radio" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.isExistDelivery,
                            expression: "isExistDelivery"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "delivery_exist_address",
                          name: "address"
                        },
                        domProps: {
                          value: true,
                          checked: _vm._q(_vm.isExistDelivery, true)
                        },
                        on: {
                          change: [
                            function($event) {
                              _vm.isExistDelivery = true
                            },
                            function($event) {
                              _vm.changeNewInput()
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "radio-label bold",
                          attrs: { for: "delivery_exist_address" }
                        },
                        [_vm._v("登録済みの郵便番号を選択する。")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content_line" }, [
                      _c(
                        "div",
                        { class: { disable_form: !_vm.isExistDelivery } },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selBusiness,
                                  expression: "selBusiness"
                                }
                              ],
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selBusiness = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    _vm.changeNewInput()
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  staticClass: "select_placeholder",
                                  attrs: { hidden: "" }
                                },
                                [_vm._v("選択ください")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.addressList, function(del, index) {
                                return _c(
                                  "option",
                                  {
                                    key: "address-" + index,
                                    domProps: { value: del }
                                  },
                                  [_vm._v(_vm._s(del.businessName))]
                                )
                              })
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.selectList
                        ? _c("div", { staticClass: "error_text middle_text" }, [
                            _vm._v(_vm._s(_vm.errors.selectList))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.isExistDelivery,
                            expression: "isExistDelivery"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "delivery_input_address",
                          name: "address"
                        },
                        domProps: {
                          value: false,
                          checked: _vm._q(_vm.isExistDelivery, false)
                        },
                        on: {
                          change: [
                            function($event) {
                              _vm.isExistDelivery = false
                            },
                            function($event) {
                              _vm.changeNewInput()
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "radio-label bold",
                          attrs: { for: "delivery_input_address" }
                        },
                        [
                          _vm._v(
                            "郵便番号を入力する。（半角数値、ハイフン不要）"
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content_line" }, [
                      _c(
                        "div",
                        { class: { disable_form: _vm.isExistDelivery } },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.deliveryForm.postcd,
                                expression: "deliveryForm.postcd"
                              }
                            ],
                            attrs: {
                              type: "text",
                              oninput:
                                "if(value.length>7)value=value.slice(0,7)"
                            },
                            domProps: { value: _vm.deliveryForm.postcd },
                            on: {
                              keypress: _vm.validateNumber,
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.deliveryForm,
                                    "postcd",
                                    $event.target.value
                                  )
                                },
                                function($event) {
                                  _vm.deliveryForm.postcd = _vm.convertHalfNumber(
                                    $event
                                  )
                                }
                              ]
                            }
                          }),
                          _c("br")
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.deliveryPostcd
                        ? _c("div", { staticClass: "error_text middle_text" }, [
                            _vm._v(_vm._s(_vm.errors.deliveryPostcd))
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.isViewConstruct
                  ? _c("section", { attrs: { id: "input_construct" } }, [
                      _c("h3", [_vm._v("⑤ 組立設置サービスの選択")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_btn_area" }, [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "button01",
                              attrs: {
                                id: "construction",
                                disabled: !_vm.isSelectConstruct
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.workFlag,
                                    expression: "workFlag",
                                    modifiers: { number: true }
                                  }
                                ],
                                class: {
                                  radio_need: _vm.isSelectConstruct,
                                  radio_need_disable: !_vm.isSelectConstruct
                                },
                                attrs: {
                                  type: "radio",
                                  name: "construction_radio",
                                  id: "construction_need",
                                  value: "1"
                                },
                                domProps: {
                                  checked: _vm._q(_vm.workFlag, _vm._n("1"))
                                },
                                on: {
                                  change: function($event) {
                                    _vm.workFlag = _vm._n("1")
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "construction_need" } },
                                [_vm._v("あり")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.workFlag,
                                    expression: "workFlag",
                                    modifiers: { number: true }
                                  }
                                ],
                                class: {
                                  radio_no: _vm.isSelectConstruct,
                                  radio_no_disable: !_vm.isSelectConstruct
                                },
                                attrs: {
                                  type: "radio",
                                  name: "construction_radio",
                                  id: "construction_no",
                                  checked: "",
                                  value: "0"
                                },
                                domProps: {
                                  checked: _vm._q(_vm.workFlag, _vm._n("0"))
                                },
                                on: {
                                  change: function($event) {
                                    _vm.workFlag = _vm._n("0")
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "construction_no" } },
                                [_vm._v("なし")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "※組立設置をご希望の場合、担当者よりご連絡いたします。"
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isOtherContruct
                            ? _c("div", { staticClass: "red" }, [
                                _vm._v(
                                  "※水道工事、電気工事は承れませんので、ご自身での手配をお願いいたします。"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isConstruct
                            ? _c("div", { staticClass: "customize_order" }, [
                                _c("div", { staticClass: "radio" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.isStructSameAddress,
                                        expression: "isStructSameAddress"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      id: "const_someaddress",
                                      name: "struct_address"
                                    },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(
                                        _vm.isStructSameAddress,
                                        true
                                      )
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          _vm.isStructSameAddress = true
                                        },
                                        function($event) {
                                          _vm.changeNewStruct()
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "radio-label bold",
                                      attrs: { for: "const_someaddress" }
                                    },
                                    [_vm._v("納品先と同じ住所")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "radio" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.isStructSameAddress,
                                        expression: "isStructSameAddress"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      id: "const_differ",
                                      name: "struct_address"
                                    },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(
                                        _vm.isStructSameAddress,
                                        false
                                      )
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          _vm.isStructSameAddress = false
                                        },
                                        function($event) {
                                          _vm.changeNewStruct()
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "radio-label bold",
                                      attrs: { for: "const_differ" }
                                    },
                                    [
                                      _vm._v(
                                        "納品先住所と異なる住所の郵便番号（半角数値、ハイフン不要）"
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content_line" }, [
                                  _c(
                                    "div",
                                    {
                                      class: {
                                        disable_form: _vm.isStructSameAddress
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.constructForm.postcd,
                                            expression: "constructForm.postcd"
                                          }
                                        ],
                                        attrs: {
                                          type: "text",
                                          oninput:
                                            "if(value.length>7)value=value.slice(0,7)"
                                        },
                                        domProps: {
                                          value: _vm.constructForm.postcd
                                        },
                                        on: {
                                          keypress: _vm.validateNumber,
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.constructForm,
                                                "postcd",
                                                $event.target.value
                                              )
                                            },
                                            function($event) {
                                              _vm.constructForm.postcd = _vm.convertHalfNumber(
                                                $event
                                              )
                                            }
                                          ]
                                        }
                                      }),
                                      _c("br")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.constructPostcd
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "error_text middle_text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.errors.constructPostcd)
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _vm.isResearch && _vm.isCarry && _vm.isHaseko
                                  ? _c(
                                      "div",
                                      { staticClass: "customize_sub" },
                                      [
                                        _c("div", { staticClass: "bold" }, [
                                          _vm._v(
                                            "受け取り搬入の有無をご入力ください。"
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "button01",
                                            attrs: { id: "construction_op" }
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: _vm.constructOpFlag,
                                                  expression: "constructOpFlag",
                                                  modifiers: { number: true }
                                                }
                                              ],
                                              staticClass: "radio_need",
                                              attrs: {
                                                type: "radio",
                                                name: "construct_op_radio",
                                                id: "construct_op_need",
                                                value: "1"
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.constructOpFlag,
                                                  _vm._n("1")
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.constructOpFlag = _vm._n(
                                                    "1"
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "construct_op_need"
                                                }
                                              },
                                              [_vm._v("あり")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: _vm.constructOpFlag,
                                                  expression: "constructOpFlag",
                                                  modifiers: { number: true }
                                                }
                                              ],
                                              staticClass: "radio_no",
                                              attrs: {
                                                type: "radio",
                                                name: "construct_op_radio",
                                                id: "construct_op_no",
                                                checked: "",
                                                value: "0"
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.constructOpFlag,
                                                  _vm._n("0")
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.constructOpFlag = _vm._n(
                                                    "0"
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "construct_op_no"
                                                }
                                              },
                                              [_vm._v("なし")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._m(0)
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isResearch && _vm.isHaseko
                  ? _c("div", { staticClass: "form" }, [
                      _c("h3", [
                        _vm._v("⑥事前現場調査の有無をご入力ください。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button01", attrs: { id: "resrch" } },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.resrchFlag,
                                expression: "resrchFlag",
                                modifiers: { number: true }
                              }
                            ],
                            staticClass: "radio_need",
                            attrs: {
                              type: "radio",
                              name: "resrch_radio",
                              id: "resrch_need",
                              value: "1"
                            },
                            domProps: {
                              checked: _vm._q(_vm.resrchFlag, _vm._n("1"))
                            },
                            on: {
                              change: [
                                function($event) {
                                  _vm.resrchFlag = _vm._n("1")
                                },
                                function($event) {
                                  _vm.changeResrch(1)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "resrch_need" } }, [
                            _vm._v("あり")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.resrchFlag,
                                expression: "resrchFlag",
                                modifiers: { number: true }
                              }
                            ],
                            staticClass: "radio_no",
                            attrs: {
                              type: "radio",
                              name: "resrch_radio",
                              id: "resrch_no",
                              value: "0"
                            },
                            domProps: {
                              checked: _vm._q(_vm.resrchFlag, _vm._n("0"))
                            },
                            on: {
                              change: [
                                function($event) {
                                  _vm.resrchFlag = _vm._n("0")
                                },
                                function($event) {
                                  _vm.changeResrch(0)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "resrch_no" } }, [
                            _vm._v("なし")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.resrchFlag === 1
                        ? _c("div", { staticClass: "input_list" }, [
                            _c("div", { staticClass: "customize_order" }, [
                              _c("div", { staticClass: "radio" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.isResrchSameAddress,
                                      expression: "isResrchSameAddress"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    id: "resrchSameAddress",
                                    name: "clone"
                                  },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(
                                      _vm.isResrchSameAddress,
                                      true
                                    )
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        _vm.isResrchSameAddress = true
                                      },
                                      function($event) {
                                        _vm.changeResrchAdress()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-label bold",
                                    attrs: { for: "resrchSameAddress" }
                                  },
                                  [_vm._v("納品先住所と同じ")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "radio" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.isResrchSameAddress,
                                      expression: "isResrchSameAddress"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    id: "resrchOtherAddress2",
                                    name: "clone"
                                  },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(
                                      _vm.isResrchSameAddress,
                                      false
                                    )
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        _vm.isResrchSameAddress = false
                                      },
                                      function($event) {
                                        _vm.changeResrchAdress()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-label bold",
                                    attrs: { for: "resrchOtherAddress2" }
                                  },
                                  [_vm._v("納品先と異なる場合")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content_line" }, [
                                _c("div", { staticClass: "bold" }, [
                                  _vm._v("※郵便番号（半角数値、ハイフン不要）")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: {
                                      disable_form:
                                        _vm.isResrchSameAddress === true
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.resrchForm.postcd,
                                          expression: "resrchForm.postcd"
                                        }
                                      ],
                                      attrs: {
                                        type: "text",
                                        oninput:
                                          "if(value.length>7)value=value.slice(0,7)"
                                      },
                                      domProps: {
                                        value: _vm.resrchForm.postcd
                                      },
                                      on: {
                                        keypress: _vm.validateNumber,
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.resrchForm,
                                              "postcd",
                                              $event.target.value
                                            )
                                          },
                                          function($event) {
                                            _vm.resrchForm.postcd = _vm.convertHalfNumber(
                                              $event
                                            )
                                          }
                                        ]
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errors.resrchPostcd
                                  ? _c(
                                      "div",
                                      { staticClass: "error_text middle_text" },
                                      [_vm._v(_vm._s(_vm.errors.resrchPostcd))]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isHaseko
                  ? _c(
                      "section",
                      [
                        _c("dd-customize-price", {
                          attrs: {
                            itemName: _vm.itemName,
                            priceData: _vm.priceData,
                            dcProductCount: _vm.targetPlan.dcProductCount,
                            profitPercent: _vm.priceData.profitPercent,
                            resrchFlag: _vm.resrchFlag
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "section",
                      [
                        _c("dd-customize-price-hrf", {
                          ref: "dcCustomizePriceHrfRef",
                          attrs: {
                            itemName: _vm.itemName,
                            priceData: _vm.profitPriceData,
                            dcProductCount: _vm.targetPlan.dcProductCount,
                            profitPercent: _vm.priceData.profitPercent,
                            resrchFlag: _vm.resrchFlag
                          }
                        }),
                        _vm._v(" "),
                        _c("dd-customize-price", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isHasekoNetOn,
                              expression: "isHasekoNetOn"
                            }
                          ],
                          attrs: {
                            itemName: _vm.itemName,
                            priceData: _vm.priceData,
                            dcProductCount: _vm.targetPlan.dcProductCount,
                            resrchFlag: _vm.resrchFlag,
                            colorType: _vm.isHasekoNetColor
                          }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    {
                      staticClass: "n_separator",
                      attrs: { id: "product_order" }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.createPlanFlag === true,
                              expression: "createPlanFlag===true"
                            }
                          ],
                          staticClass: "lds-sub-spinner"
                        },
                        [_vm._m(1)]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "product_order_line total_price" },
                        [
                          _vm.targetPlan.dcCategoryType !== 5 && !_vm.resrchFlag
                            ? _c("div", { attrs: { id: "order_cnt" } }, [
                                _c("label", [_vm._v("ご注文数")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: _vm.targetPlan.dcProductCount,
                                      expression: "targetPlan.dcProductCount",
                                      modifiers: { number: true }
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    maxlength: "3",
                                    id: "product_cnt"
                                  },
                                  domProps: {
                                    value: _vm.targetPlan.dcProductCount
                                  },
                                  on: {
                                    keypress: _vm.validateNumber,
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.targetPlan,
                                          "dcProductCount",
                                          _vm._n($event.target.value)
                                        )
                                      },
                                      function($event) {
                                        _vm.targetPlan.dcProductCount = _vm.inputRestNumber(
                                          $event
                                        )
                                      }
                                    ],
                                    blur: [
                                      _vm.onBlurProductCount,
                                      function($event) {
                                        _vm.$forceUpdate()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", [_vm._v("点")])
                              ])
                            : _c("div"),
                          _vm._v(" "),
                          _c("div", { staticClass: "space" }),
                          _vm._v(" "),
                          _c("div", [
                            _c("img", {
                              staticClass: "icon_calc",
                              attrs: { src: _vm.imgCalc }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "bold" }, [
                              _vm._v("合計金額（税込）")
                            ])
                          ]),
                          _vm._v(" "),
                          !_vm.isHaseko
                            ? [
                                _vm.resrchFlag
                                  ? _c(
                                      "div",
                                      { staticClass: "price big_text2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatPrice(
                                              _vm.priceData.resrchTotalPrice
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : !_vm.isPlanning
                                    ? _c(
                                        "div",
                                        { staticClass: "price big_text2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatPrice(
                                                _vm.priceData.totalTax
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "price big_text2" },
                                        [_vm._v(_vm._s(_vm.priceCalcText))]
                                      )
                              ]
                            : [
                                _vm.resrchFlag
                                  ? _c(
                                      "div",
                                      { staticClass: "price big_text2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatPrice(
                                              _vm.profitPriceData
                                                .resrchTotalPrice
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : !_vm.isPlanning
                                    ? _c(
                                        "div",
                                        { staticClass: "price big_text2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatPrice(
                                                _vm.profitPriceData.totalTax
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "price big_text2" },
                                        [_vm._v(_vm._s(_vm.priceCalcText))]
                                      )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "order_action_area" }, [
                        _c("div", { staticClass: "support_area" }, [
                          _c(
                            "div",
                            {
                              staticClass: "detail_btn4",
                              on: {
                                click: function($event) {
                                  _vm.route("SupportInput", {
                                    maker: _vm.targetPlan.makerData.corpId
                                  })
                                }
                              }
                            },
                            [_vm._v("この商品について問い合わせる")]
                          ),
                          _vm._v(" "),
                          _vm.isHaseko
                            ? _c(
                                "div",
                                {
                                  class: {
                                    main_btn: true,
                                    act_sub_btn2: true,
                                    net_button: true
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.onNet()
                                    }
                                  }
                                },
                                [_c("a", [_vm._v("N")])]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "space" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: {
                              action_area: true,
                              disabled: !_vm.isExecOrder
                            }
                          },
                          [
                            _vm.isOutputCG && !_vm.isMiuraCompany
                              ? _c(
                                  "div",
                                  {
                                    class: {
                                      main_btn: true,
                                      act_sub_btn2: true
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.onCgOuput()
                                      }
                                    }
                                  },
                                  [_c("a", [_vm._v("CG出力")])]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            false
                              ? _c(
                                  "div",
                                  {
                                    class: {
                                      main_btn: true,
                                      act_sub_btn2: true
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.onReEstimate()
                                      },
                                      mouseover: function($event) {
                                        _vm.isOnReload(true)
                                      },
                                      mouseleave: function($event) {
                                        _vm.isOnReload(false)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "icon",
                                      attrs: { src: _vm.imgReload }
                                    }),
                                    _vm._v(" "),
                                    _c("a", [_vm._v("再計算")])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isGuestUser
                              ? _c(
                                  "div",
                                  {
                                    class: {
                                      main_btn: true,
                                      act_sub_btn2: true
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.save()
                                      },
                                      mouseover: function($event) {
                                        _vm.isOnSave(true)
                                      },
                                      mouseleave: function($event) {
                                        _vm.isOnSave(false)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "icon",
                                      attrs: { src: _vm.imgSave }
                                    }),
                                    _vm._v(" "),
                                    _c("a", [_vm._v("入力内容保存")])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resrchFlag
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "main_btn sel_main_btn",
                                      on: {
                                        click: function($event) {
                                          _vm.resrch()
                                        }
                                      }
                                    },
                                    [_c("a", [_vm._v("事前現場調査見積り")])]
                                  )
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "main_btn sel_main_btn",
                                      on: {
                                        click: function($event) {
                                          _vm.onShowEstimateModal()
                                        }
                                      }
                                    },
                                    [
                                      _c("a", [
                                        _vm._v(_vm._s(_vm.estimteBtnTitle))
                                      ])
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ])
                    ]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "customize_sub" }, [
      _c("ul", [
        _c("li", [_vm._v("組立設置オプションには以下の費用が発生します。")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("組立技術料：組立作業費および副資材、簡易養生材など。")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("諸経費：交通費、燃料代など。")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-spinner lds-spinner-pos" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e536e0d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e536e0d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcCustomize.vue
// module id = null
// module chunks = 